module.exports = __webpack_public_path__ + "img/python.94a629c9.png";